import React, { useEffect, useState } from "react";
import { InputField, NXForm } from "../../common";
import NxtbnDrawer from "../../drawer";
import useApi from "../../../api";
import { toast } from "react-toastify";
import SelectStyled from "../../Select";
import enumChoice, { getEnumItem } from "../../../enum";

interface AddressFormProps {
    userId?: number;
    edit?: any;
    isOpen: boolean;
    onClose: ()=>void;
    refresh: ()=>void;
}
function AddressForm({ userId, edit, isOpen, onClose, refresh }:AddressFormProps) {

  const [formData, setFormData] = useState<any>(edit ? edit : {})
  const [errorData, setErrorData] = useState<any>({});
  const api = useApi()

  const handleInputChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData((prev:any)=>({
      ...prev,
      [name]: value
    }))
  }

  const handleSelect = (e: any, field:any) => {
    setFormData((prev:any)=>({
      ...prev,
      [field]: e.value
    }))
  }

  useEffect(()=>{
    if (!edit) {
      setFormData((prev:any)=>({
        ...prev,
        user: userId
      }))
    }
  }, [])

  const onSubmit = (e: React.FormEvent<any>) => {
    e.preventDefault()
    if (edit){
      api.updateAddress(edit.id, formData).then((response:any)=>{
        toast.success('Successfully updated address.')
        refresh()
        onClose()
      }).catch((error)=>{
        setErrorData(error.response.data)
        toast.error('Error updated address.')
      })
    }else {
 
      api.addAddress(formData).then((response:any)=>{
        toast.success('Successfully added address.')
        refresh()
        onClose()
      }).catch((error)=>{
        setErrorData(error.response.data)
        toast.error('Error added address.')
      })
    }
  }


  return (
    <NxtbnDrawer size="md" title={edit ? 'Edit Address' : 'Add Address'} isOpen={isOpen} onClose={onClose}>
        <NXForm
          onSubmit={onSubmit}
        >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">First Name</label>
            <InputField
              type="text"
              name="first_name"
              placeholder="First Name"
              value={formData?.first_name || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Last Name</label>
            <InputField
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={formData?.last_name || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Street Address</label>
            <InputField
              type="text"
              name="street_address"
              placeholder="Street Address"
              value={formData?.street_address || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">City</label>
            <InputField
              type="text"
              name="city"
              placeholder="City"
              value={formData?.city || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">State</label>
            <InputField
              type="text"
              name="state"
              placeholder="State"
              value={formData?.state || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Postal Code</label>
            <InputField
              type="text"
              name="postal_code"
              placeholder="Postal Code"
              value={formData?.postal_code || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Country</label>
            <InputField
              type="text"
              name="country"
              placeholder="Country"
              value={formData?.country || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Address Phone Number</label>
            <InputField
              type="text"
              name="phone_number"
              placeholder="Address Phone Number"
              value={formData?.phone_number || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
        </div>

        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="px-4 py-2 bg-black text-white rounded">
            { edit ? 'Update Address' : 'Add Address'}
          </button>
        </div>
      </NXForm>
    </NxtbnDrawer>
  )
}

export default AddressForm